import React, { Component } from 'react'
import { Modal, Button } from 'antd'

export default class extends Component {
  handleOk = (e) => {
    const { rows } = this.props.storage.table

    if (rows.length === 1) {
      this.props.deleteStorageResourceById(rows[0].guid).then(() => {
        this.props.setTable([], [])
        this.handleCancel()
      })
    } else {
      let guids = rows.map((record) => {
        return record.guid
      })
      this.props.deleteStorageResourceByArray({ guids }).then(() => {
        this.props.setTable([], [])
        this.handleCancel()
      })
    }
  }

  handleCancel = (e) => {
    this.props.closeModal()
  }

  render () {
    const { table: { rows }, isDeleting } = this.props.storage

    return (
      <Modal
        wrapClassName='vertical-center-modal'
        width={320}
        visible={this.props.status}
        onOk={this.handleOk}
        onCancel={this.handleCancel}
        destroyOnClose
        footer={[
          <Button key='back' onClick={this.handleCancel}>Cancel</Button>,
          <Button key='submit' type='red' loading={isDeleting} onClick={this.handleOk}>Delete</Button>
        ]}
      >
        <h4>Are you sure you want to delete { rows.length > 1 ? 'these files' : 'this file' }?</h4>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Modals/StorageDeleteModal/StorageDeleteModal.jsx